var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.onSeason)?_c('div',{staticClass:"seasonal-christmas"},[_c('div',{staticClass:"main-header__christmas",class:{ 'main-header__christmas--partner-logo': _vm.partnerLogoRendered }})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }